import React, { useState } from "react";
import Swal from "sweetalert2";
import { useUpdateData } from "hooks/useApiHooks";

const ChangeSusukStatusButton = ({ booking, refetch }) => {
  const API_URL = "/reservation/change-status-susuk-agent";
  const { updateData } = useUpdateData(API_URL);
  const [loading, setLoading] = useState(false);

  // Tentukan status saat ini dan status selanjutnya
  const isPaid = booking.status_susuk_agent === "paid";
  const nextStatus = isPaid ? "hold" : "paid"; // Jika "paid", ubah ke "hold", dan sebaliknya

  const handleStatusChange = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Change status to ${nextStatus.toUpperCase()}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        await updateData({
          reservation_ids: [booking.id],
          status_susuk_agent: nextStatus,
        });
        Swal.fire(
          "Success",
          `Status changed to ${nextStatus.toUpperCase()}`,
          "success"
        );
        refetch(); // Refresh data setelah perubahan status berhasil
      } catch (error) {
        console.error("Error updating status:", error);
        Swal.fire("Error", "Failed to update status", "error");
      }
      setLoading(false);
    }
  };

  return (
    <button
      className={`btn ms-2 text-uppercase ${
        isPaid ? "btn-success" : "btn-danger"
      }`}
      onClick={handleStatusChange}
      disabled={loading} // Nonaktifkan tombol selama proses update
    >
      {loading ? "Updating..." : isPaid ? "Paid" : "Hold"}
    </button>
  );
};

export default ChangeSusukStatusButton;
